var render, staticRenderFns
import script from "./SliderBar.vue?vue&type=script&lang=js&"
export * from "./SliderBar.vue?vue&type=script&lang=js&"
import style0 from "./SliderBar.vue?vue&type=style&index=0&id=284a8e39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284a8e39",
  null
  
)

export default component.exports